export enum ancTypes {
  first = '1',
  second = '2',
  third = '3',
  fourth = '4',
}

export const ancTypesList: ancTypes[] = [
  ancTypes.first,
  ancTypes.second,
  ancTypes.third,
  ancTypes.fourth,
];

export const ancTypeToWidth = {
  [ancTypes.first]: 'w-1/4',
  [ancTypes.second]: 'w-1/2',
  [ancTypes.third]: 'w-3/4',
  [ancTypes.fourth]: 'w-full',
};

export const ancTypeToHeight = {
  [ancTypes.first]: 'h-[64px]',
  [ancTypes.second]: 'h-[42.5%]',
  [ancTypes.third]: 'h-[67.5%]',
  [ancTypes.fourth]: 'h-[92.5%]',
};
